export {
    modalsSelectors,
    modalsSliceActions,

    selectModalData,

    closeModal,
    openModal,
} from './modals-slice';

export type {
    TModalComponentInterface,
} from './modals-slice-types';
